<template>
	<div class="view z-[1] pt-[80px]">
		<iframe v-for="(iframe, key) in $store.state.results" v-show="result.url == iframe.url" :key="key" ref="iframe"
			:src="iframe.url" scrolling="no" style="border: none" width="100%" :height="height"></iframe>
	</div>

</template>

<script>
export default {
	name: 'ResiltsTemplate',
	computed: {
		result() {
			return this.$store.getters.result;
		},
		height() {
			return (window.innerHeight - 80) + 'px';
		}
	}
}
</script>